import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchSalesOverview = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.STORE_SALES]}`,
)
